import React from "react"
import "firebase/auth"
import "firebase/firestore"
import "firebase/functions"
import PersistentChat from "./src/components/persistent-chat/persistent-chat"

export const onRouteUpdate = () => {
  window.locations = window.locations || [document.referrer]
  if (window.locations[window.locations.length - 1] !== window.location.href) {
    window.locations.push(window.location.href)
  }
  window.previousPath = window.locations[window.locations.length - 2]
}

// wrapRootElement mounts once for the lifetime of the SPA —
// the PersistentChat (and its mkbsd-ai session) survives page navigation.
export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <PersistentChat />
  </>
)
